import { render } from "./CapaNazgulView.vue?vue&type=template&id=8af909e0"
import script from "./CapaNazgulView.vue?vue&type=script&lang=js"
export * from "./CapaNazgulView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__